exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*** variables ***/\n/*** mixins ***/\n.wrap[data-v-2326f158] {\n  max-width: 1200px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin: 40px auto 0;\n}\n@media (max-width: 576px) {\n.wrap[data-v-2326f158] {\n    width: 100%;\n    padding: 0 37px;\n    margin: 0 auto;\n}\n}", ""]);

// exports
